import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { mount } from '../dom-lifecycle';

async function addFingerprint(form) {
	const input = $('<input type="hidden" name="fingerprint">').appendTo(form);
	const fp = await FingerprintJS.load();
	const { visitorId } = await fp.get();
	input.val(visitorId);
};

mount('.application-form', async (form) => await addFingerprint(form));